"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.maxRowsCollapsed = exports.maxRowsExpanded = void 0;
exports.maxRowsExpanded = 7;
exports.maxRowsCollapsed = 1;
